import React from 'react';
import { getCleanUserHtmlWithMetadata } from '../utils/cleanUserHtml';
export const SecureUserHtml = React.memo(function ({ html, containerProps, }) {
    const { html: cleanHtml } = getCleanUserHtmlWithMetadata(html);
    return (React.createElement("div", { ...containerProps, dangerouslySetInnerHTML: { __html: cleanHtml } }));
});
//# sourceMappingURL=SecureUserHtml.js.map